import type { InstanceListOption } from '../types';
import { getStoredInstanceByName } from './getStoredInstanceByName';

export const getDefaultInstance = (
  instancesList: InstanceListOption[] | null | undefined,
  useStoredInstance = true
): InstanceListOption | null => {
  // With a single instance there is nothing to choose from, so pre-select it (the user still has to confirm)
  if (instancesList?.length === 1) {
    return instancesList[0];
  }

  return (useStoredInstance && getStoredInstanceByName(instancesList)) || null;
};
